<script setup>
import {ref} from 'vue'
import {useUniqueValue} from '@/composables/useUniqueValue'
import vFormValidation from '@/vue/directives/formValidation'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: String // Added to support the watch target inside the composable
})

// Accessing the DOM element for validation side-effects
const fieldInputRef = ref(null)

// Initialize Vue 3 style composable logic
useUniqueValue(props, fieldInputRef)

// Instantiate dynamic Pinia Form Store
const formStore = useFormStore(props.formId)

// Emulating the created hook logic
formStore.setDefaultValue({
    name: props.field.name,
    value: ''
})
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <input v-else :id="field.id" ref="fieldInputRef" v-model="currentData[field.name]" v-select="field.autofocus"
           v-form-validation
           :disabled="field.disabled" :max="field.max" :min="field.min" :name="field.name" :required="field.required"
           :step="field.step" autocomplete="off" class="form-control" :class="{'is-invalid': field.error}" type="month">
</template>